import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import api, { apiError } from "@/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=user
  const [error, setError] = useState("");

  useEffect(() => {
    // Saat kembali dari Google OAuth, AuthCallback yang menukar session_id lebih dulu
    if (window.location.hash?.includes("session_id=")) return;
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const loginWithGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/events";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const exchangeGoogleSession = async (sessionId) => {
    setError("");
    try {
      const { data } = await api.post("/auth/google/session", { session_id: sessionId });
      setUser(data);
      return true;
    } catch (e) {
      setError(apiError(e));
      setUser(false);
      return false;
    }
  };

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      return true;
    } catch (e) {
      setError(apiError(e));
      return false;
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.error("Logout gagal:", e); }
    setUser(false);
  };

  const value = useMemo(() => ({ user, login, logout, error, loginWithGoogle, exchangeGoogleSession }), [user, error]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
